// extracted by mini-css-extract-plugin
module.exports = {"applied":"Applied_applied__2LSpO"};